export const getInvertedArrowsNames = (isInverted: boolean, isIncreasing: boolean) => {
    const invertedArrows = isIncreasing ? "arrow-up-red" : "arrow-down-green";
    const defaultArrows = isIncreasing ? "arrow-up" : "arrow-down";

    return isInverted ? invertedArrows : defaultArrows;
};
